export enum ChallengesWsEvents {
  userMissionUpdated = 'userMission.updated',
}
